// extracted by mini-css-extract-plugin
export default {"container":"container_sZWBg","heading":"heading_UYoQ0","title":"title_OO9lm","button":"button_Rv4oj","total":"total_eyd1g","audience":"audience_HLRUe"};